import { z } from 'zod';

import { gymIdsSearchSchema } from '@/screens/gym-catalog/gym-catalog-query';

/**
 * What the create page can be opened with.
 *
 * Both fields come from the food-requests screen: a request names a food the
 * catalog does not have, so "create this food" hands over the name the user
 * typed and the request it should close. Everything `.catch(undefined)`, so a
 * stale link degrades to an empty form rather than an error page.
 */
export const foodNewSearchSchema = z.object({
  /** Prefills the name, so an operator does not retype what the user already wrote. */
  name: z.string().trim().min(1).max(160).optional().catch(undefined),
  /** The request this food answers. Resolved after the food exists. */
  requestId: z.string().uuid().optional().catch(undefined),
  /**
   * "From gyms": the gym foods this catalog food is made from, comma-separated.
   * Linked after the food exists, as a request is resolved.
   */
  gymFoodIds: gymIdsSearchSchema,
});

export type FoodNewSearch = z.infer<typeof foodNewSearchSchema>;
